<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <div class="container-fluid d-flex flex-wrap justify-content-between text-center container-p-x pb-3">
      <div class="pt-3"><span class="footer-text font-weight-bolder">SPB v.1.00</span>
      </div> 
      <div>
        <a href="http://www.fulltechpro.com.br" target="blank" class="footer-link pt-3 d-block small">© FULLTECH Tecnologia e Serviços Ltda - Todos os direitos reservados</a>
      </div>
  </div>
  </nav>
</template>

<script>
export default {
  name: 'app-layout-footer',

  methods: {
    getLayoutFooterBg () {
      return `bg-${this.layoutFooterBg}`
    }
  }
}
</script>
